export default "__VITE_ASSET__CJ6MBZqY__"